'use strict';

exports.__esModule = true;
exports.getDefaultValueByIdentifier = undefined;

var _HANDLERS;

var _Identifiers = require('../../types/Identifiers');

var _ContextProps = require('../../types/ContextProps');

var _getByIdentifier = require('../values/get-by-identifier');

var _sanitizeUrl = require('../../utils/sanitize-url');

var HANDLERS = (_HANDLERS = {}, _HANDLERS[_Identifiers.IDENTIFIERS.TITLE] = getDefaultTitle, _HANDLERS[_Identifiers.IDENTIFIERS.DESCRIPTION] = getDefaultDescription, _HANDLERS[_Identifiers.IDENTIFIERS.OG_TITLE] = getDefaultOgTitle, _HANDLERS[_Identifiers.IDENTIFIERS.OG_DESCRIPTION] = getDefaultOgDescription, _HANDLERS[_Identifiers.IDENTIFIERS.OG_IMAGE] = getDefaultOgImage, _HANDLERS[_Identifiers.IDENTIFIERS.OG_URL] = getDefaultOgUrl, _HANDLERS[_Identifiers.IDENTIFIERS.OG_SITE_NAME] = getDefaultOgSiteName, _HANDLERS[_Identifiers.IDENTIFIERS.FB_ADMINS] = getDefaultFbAdmins, _HANDLERS[_Identifiers.IDENTIFIERS.OG_TYPE] = getDefaultOgType, _HANDLERS[_Identifiers.IDENTIFIERS.CANONICAL] = getDefaultCanonicalUrl, _HANDLERS);

var getDefaultValueByIdentifier = exports.getDefaultValueByIdentifier = function getDefaultValueByIdentifier(tags, identifier, context) {
  return (HANDLERS[identifier] || getDefault)(context, tags);
};

function getDefault() {
  return undefined;
}

function getDefaultTitle(context) {
  if (context[_ContextProps.CONTEXT_PROPS.TITLE]) {
    return context[_ContextProps.CONTEXT_PROPS.TITLE];
  }
  if (context[_ContextProps.CONTEXT_PROPS.IS_HOME_PAGE]) {
    return context[_ContextProps.CONTEXT_PROPS.SITE_NAME] || '';
  }
  return [context[_ContextProps.CONTEXT_PROPS.PAGE_NAME], context[_ContextProps.CONTEXT_PROPS.HOME_PAGE_TITLE] || context[_ContextProps.CONTEXT_PROPS.SITE_NAME]].filter(function (_) {
    return !!_;
  }).join(' | ');
}

function getDefaultDescription(context) {
  return context[_ContextProps.CONTEXT_PROPS.DESCRIPTION];
}

function getDefaultOgTitle(context, tags) {
  return (0, _getByIdentifier.getValueByIdentifier)(tags, _Identifiers.IDENTIFIERS.TITLE) || getDefaultTitle(context, tags);
}

function getDefaultOgDescription(context, tags) {
  return (0, _getByIdentifier.getValueByIdentifier)(tags, _Identifiers.IDENTIFIERS.DESCRIPTION) || getDefaultDescription(context, tags);
}

function getDefaultOgImage(context) {
  return context[_ContextProps.CONTEXT_PROPS.OG_IMAGE] || context[_ContextProps.CONTEXT_PROPS.SITE_OG_IMAGE];
}

function getDefaultCanonicalUrl(context) {
  return (0, _sanitizeUrl.sanitizeUrl)(context[_ContextProps.CONTEXT_PROPS.DEFAULT_URL]);
}

function getDefaultOgType() {
  return 'website';
}

function getDefaultFbAdmins(context) {
  return context[_ContextProps.CONTEXT_PROPS.FB_ADMINS];
}

function getDefaultOgSiteName(context) {
  return context[_ContextProps.CONTEXT_PROPS.SITE_NAME];
}

function getDefaultOgUrl(context) {
  return getDefaultCanonicalUrl(context);
}